module.exports = __webpack_public_path__ + "static/flags/MD-d546f881a0786acb6590b5de2652a833.gif";